import { j as t } from "../../../../jsx-runtime-B3iL8JI7.js";
import { faTriangleExclamation as e } from "@fortawesome/pro-solid-svg-icons";
import "../../../atoms/Button/Button.styles.js";
import "@fortawesome/pro-duotone-svg-icons";
import a from "../../../atoms/Icon/Icon.js";
import "../../../../tailwindConfig/bclTwMerge.js";
import "@radix-ui/react-checkbox";
import "../../../atoms/Checkbox/Checkbox.styles.js";
import "../../../atoms/Loader/SYFLoader/SyfLoader.js";
import "../../../atoms/ProgressIndicator/ProgressIndicator.styles.js";
import "react";
import "@radix-ui/react-select";
import "../../../atoms/TextField/TextField.styles.js";
import "../../../atoms/TextLink/TextLink.styles.js";
import "../../../atoms/Chip/Chip.styles.js";
import "@radix-ui/react-radio-group";
import "../../../atoms/RadioItem/RadioItem.styles.js";
const i = (r) => `${r}-error-text`, v = ({ id: r, text: o, ariaLive: m }) => /* @__PURE__ */ t.jsx(
  "p",
  {
    id: i(r),
    className: "flex items-center text-caption-xs text-error",
    "aria-live": m,
    "data-testid": i(r),
    children: o && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(
        a,
        {
          className: "mr-1",
          icon: e,
          "data-testid": `${r}-error-icon`,
          "aria-hidden": !0
        }
      ),
      o
    ] })
  }
);
export {
  v as default,
  i as getErrorId
};
